// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[role=\"progressbar\"] span{color:black;min-width:4em}.text-default span{color:#337ab7}.text-success span{color:#5cb85c}.text-danger span{color:#d9534f}.progress-msg-wrapper{text-align:center}.progress-msg-wrapper>div{margin:0 auto}\n", ""]);
// Exports
module.exports = exports;
